import { Controller } from "@hotwired/stimulus"

// Toggles visibility of a content section with a show/hide trigger.
//
// Usage:
//   <div data-controller="reveal">
//     <a href="#" data-action="reveal#toggle" data-reveal-target="trigger"
//        data-reveal-show-text="Show more" data-reveal-hide-text="Show less">Show more</a>
//     <div data-reveal-target="content" style="display: none;">
//       Hidden content here
//     </div>
//   </div>
//
// Values:
//   open (Boolean) - whether the content starts visible (default: false)
//
export default class extends Controller {
  static targets = ["content", "trigger"]
  static values = { open: { type: Boolean, default: false } }

  connect() {
    this.contentTargets.forEach(el => {
      el.style.display = this.openValue ? "" : "none"
    })
    this.#updateTriggerText()
  }

  toggle(e) {
    if (e) e.preventDefault()
    this.openValue = !this.openValue
    this.contentTargets.forEach(el => {
      el.style.display = this.openValue ? "" : "none"
    })
    this.#updateTriggerText()
  }

  #updateTriggerText() {
    this.triggerTargets.forEach(el => {
      const showText = el.dataset.revealShowText
      const hideText = el.dataset.revealHideText
      if (showText && hideText) {
        el.textContent = this.openValue ? hideText : showText
      }
      el.setAttribute("aria-expanded", this.openValue)
    })
  }
}
